import { createStore, combineReducers, applyMiddleware } from 'redux'

import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'

import authReducer from 'common/redux/auth'
import rootReducer from 'common/redux/root'
import referralListReducer from 'manager/redux/referral_list'
import referralReducer from 'manager/redux/referral'
import referralStatusReducer from 'manager/redux/referral_status'
import referralOptOutReducer from 'manager/redux/referral_opt_out'
import managerDashboardReducer from 'manager/redux/dashboard'
import onboardReducer from 'manager/redux/onboard'
import settingsReducer from 'manager/redux/settings'
import settlementProviderSearchReducer from 'manager/redux/settlement_provider_search'

import { reducer as modalReducer } from 'redux-modal'

import { routerReducer } from 'react-router-redux'
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';

import errorMiddleware from 'common/middleware/error'
import loaderMiddleware from 'common/middleware/loader'
import {analyticsMiddleware, analyticsReducer} from "manager/analytics"
import envConfigReducer from "manager/redux/env_config"

const logger = createLogger()
const router = routerMiddleware(browserHistory)

const initialState = {
  auth: {
    user: window.OD.initialState.user,
    is_delinquent_broker: false,
  },
  envConfig: window.OD.initialState.env_config
}

export default () => (
    createStore(
      combineReducers({
        root: rootReducer,
        auth: authReducer,
        routing: routerReducer,
        modal: modalReducer,
        referralList: referralListReducer,
        referral: referralReducer,
        referralStatus: referralStatusReducer,
        referralOptOut: referralOptOutReducer,
        managerDashboard: managerDashboardReducer,
        onboard: onboardReducer,
        settings: settingsReducer,
        settlementProviderSearch: settlementProviderSearchReducer,
        analytics: analyticsReducer,
        envConfig: envConfigReducer,
      }),
      initialState,
      applyMiddleware(router, thunk, logger, errorMiddleware, loaderMiddleware, analyticsMiddleware),
    )
)
